<template>
  <div class="bg-white rounded px-3 py-2">
    <div class="d-flex align-items-center pt-2">
      <em class="fas fa-info-circle color-orange" />
      <span class="font-16 color-gray-7 ml-1">Información General</span>
    </div>
    <div class="row mt-3">
      <div class="col-12 col-md-2 mt-3 mt-md-0">
        <custom-input-display
          class="span-student ml-0"
          label-class="text-gray font-weight-light font-14"
          label="Duración:"
          :value="item.durationName"
        />
      </div>
      <div class="col-12 col-md-2 mt-3 mt-md-0">
        <custom-input-display
          class="span-student ml-0"
          label-class="text-gray font-weight-light font-14"
          label="Horas Registradas:"
          :value="item.registeredHours"
        />
      </div>
      <div class="col-12 col-md-2 mt-3 mt-md-0">
        <custom-input-display
          class="span-student ml-0"
          label-class="text-gray font-weight-light font-14"
          label="Balance:"
          :value="item.balance"
        />
      </div>
    </div>
  </div>
</template>
<script>
//libs
import CustomInputDisplay from 'CustomInputDisplay';
export default {
  name: 'SearchResultGeneralInfo',
  components: {
    CustomInputDisplay,
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>
